{
  "source": "public/brand-logo-idea.png#M",
  "crop": {
    "left": 1094,
    "top": 200,
    "width": 370,
    "height": 174
  },
  "sourceBounds": {
    "left": 35,
    "right": 331,
    "top": 16,
    "baseline": 158
  },
  "geometryBounds": {
    "top": 20,
    "baseline": 86
  },
  "opticalAdjustments": [
    0,
    2.057,
    5.345,
    3.19,
    6.134,
    0.69
  ],
  "controls": [
    {
      "x": 0,
      "y": 86
    },
    {
      "x": 0.04,
      "y": 85.501
    },
    {
      "x": 0.12,
      "y": 53
    },
    {
      "x": 0.2,
      "y": 29
    },
    {
      "x": 0.32,
      "y": 51
    },
    {
      "x": 0.5,
      "y": 76
    },
    {
      "x": 0.68,
      "y": 51
    },
    {
      "x": 0.8,
      "y": 29
    },
    {
      "x": 0.88,
      "y": 53
    },
    {
      "x": 0.96,
      "y": 85.501
    },
    {
      "x": 1,
      "y": 86
    }
  ]
}
